import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BulkUploadFormComponent } from './bulk-upload-form/bulk-upload-form.component';

const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form/:id',
    component: BulkUploadFormComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BulkUploadRoutingModule { }
